<template>
  <div class="container">
    <h2 class="mt-4">{{ $t('edit_group') }}</h2>

    <!-- Success and Error Messages -->
    <div v-if="successMessage" class="alert alert-success alert-dismissible fade show fixed-alert" role="alert">
      {{ successMessage }}
      <button type="button" class="btn-close" @click="successMessage = ''"></button>
    </div>

    <div v-if="errorMessage" class="alert alert-danger alert-dismissible fade show fixed-alert" role="alert">
      {{ errorMessage }}
      <button type="button" class="btn-close" @click="errorMessage = ''"></button>
    </div>

    <form @submit.prevent="submitGroup">
      <div class="mb-3">
        <label for="groupName" class="form-label">{{ $t('group_name') }}</label>
        <input v-model="groupForm.name" type="text" class="form-control" id="groupName" required/>
      </div>

      <!-- Permissions -->
      <div class="mb-3">
        <label class="form-label">{{ $t('permissions') }}</label>
        <div class="row">
          <div v-for="(permission, index) in paginatedPermissions" :key="permission.id" class="col-3 mb-2">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :value="permission.id" v-model="groupForm.permissions"
                     :id="'permission-' + permission.id">
              <label class="form-check-label" :for="'permission-' + permission.id">{{ permission.name }}</label>
            </div>
          </div>
        </div>
        <!-- Pagination Controls -->
        <div class="pagination-controls mt-3">
          <button type="button" class="btn btn-light" @click="previousPage" :disabled="currentPage === 1">
            <img src="@/assets/previous_page.png" alt="{{ $t('previous') }}" style="width: 20px; margin-right: 5px;">
          </button>
          <span>{{ $t('page') }} {{ currentPage }} {{ $t('of') }} {{ totalPages }}</span>
          <button type="button" class="btn btn-light" @click="nextPage" :disabled="currentPage === totalPages">
            <img src="@/assets/next_page.png" alt="{{ $t('next') }}" style="width: 20px; margin-right: 5px;">
          </button>
        </div>
      </div>
      <button type="submit" class="btn btn-primary">{{ $t('update') }}</button>
      <router-link to="/groups" class="btn btn-secondary">{{ $t('cancel') }}</router-link>
    </form>
  </div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'GroupEdit',
  data() {
    return {
      groupForm: {
        id: null,
        name: '',
        permissions: []
      },
      permissions: [],
      successMessage: '',
      errorMessage: '',
      currentPage: 1,
      itemsPerPage: 48 // 4 columns x 12 rows = 48 permissions per page
    };
  },
  computed: {
    paginatedPermissions() {
      // Calculate start and end indices for permissions on the current page
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.permissions.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.permissions.length / this.itemsPerPage);
    }
  },
  mounted() {
    this.getGroup();
    this.getPermissions();
  },
  methods: {
    async getGroup() {
      try {
        const response = await axios.get(`/api/v1/admin/groups/${this.$route.params.id}/`);
        this.groupForm = {
          id: response.data.id,
          name: response.data.name,
          permissions: response.data.permissions.map(p => p.id)
        };
      } catch (error) {
        this.errorMessage = 'Failed to fetch group details';
        this.showMessageTimeout('error');
      }
    },
    async getPermissions() {
      try {
        const response = await axios.get('/api/v1/admin/permissions/');
        this.permissions = response.data.results;
      } catch (error) {
        this.errorMessage = 'Failed to fetch permissions';
        this.showMessageTimeout('error');
      }
    },
    async submitGroup() {
      try {
        const payload = {
          name: this.groupForm.name,
          permission_ids: this.groupForm.permissions
        };
        await axios.patch(`/api/v1/admin/groups/${this.groupForm.id}/`, payload);
        this.successMessage = 'Group updated successfully';
        this.showMessageTimeout('success');
      } catch (error) {
        this.errorMessage = 'Failed to update group';
        this.showMessageTimeout('error');
      }
    },
    previousPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    showMessageTimeout(type) {
      setTimeout(() => {
        if (type === 'success') {
          this.successMessage = '';
          this.$router.push('/groups');
        } else {
          this.errorMessage = '';
        }
      }, 2000);
    }
  }
};
</script>

<style scoped>
.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
